const getters = {
  app: state => state.app.global
}
export default getters
